import { render, staticRenderFns } from "./booking-modal.vue?vue&type=template&id=08ccea4e&scoped=true"
import script from "./booking-modal.vue?vue&type=script&lang=ts"
export * from "./booking-modal.vue?vue&type=script&lang=ts"
import style0 from "./booking-modal.vue?vue&type=style&index=0&id=08ccea4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ccea4e",
  null
  
)

export default component.exports